// 헤더 탭 줄의 「더보기 ▾」 메뉴 (2026-09-29 인사 화면 일관성 §6).
//
// 무엇을 숨길지는 global-nav.html 의 인라인 스크립트(window.fitNavTabs — 규칙은
// nav-tabs-fit.js 의 tabsToHide)가 정한다. 이 모듈은 메뉴만 맡는다: 단추가 목록을
// 열고 닫고, 목록 안에서 ↑↓ · Home · End 로 옮겨 다닌다. Esc · 바깥 클릭은 공용 팝오버
// 등록부가 닫고, 닫힐 때 포커스가 목록 안에 있었으면 단추로 돌려준다.
//
// 탭 줄(.navbar-tabs)은 SPA 이동 · 모듈 공개 토글마다 innerHTML 로 통째로 갈아끼워진다
// (calendar-history.js syncNavTabs). 그래서 리스너는 전부 문서에 한 번 위임하고, 요소는
// 쓸 때마다 찾는다 — 교체된 옛 요소를 붙들지 않는다.

import { openExclusive, closedExclusive } from './popover-registry.js';

const POP_ID = 'navbar-more';
const BUTTON = '.navbar-tabs .navbar-more';
const LIST = '.navbar-tabs .navbar-more-list';

function parts() {
    return { button: document.querySelector(BUTTON), list: document.querySelector(LIST) };
}

// 보이는 사본(숨긴 탭의 사본)만 — 목록 순서 그대로.
function visibleItems(list) {
    return Array.from(list.querySelectorAll('li:not([hidden]) > .navbar-more-item'));
}

function isOpen() {
    const { list } = parts();
    return !!list && !list.hidden;
}

// hide closes the list; restoreFocus puts focus back on the button (keyboard use).
function hide(restoreFocus) {
    const { button, list } = parts();
    if (list) list.hidden = true;
    if (button) {
        button.setAttribute('aria-expanded', 'false');
        if (restoreFocus) button.focus();
    }
}

// close is the module's own close (toggle, item click, Tab): it also clears the
// registry entry, which Esc / outside click clear by calling the closeFn below.
function close(restoreFocus) {
    closedExclusive(POP_ID);
    hide(restoreFocus);
}

function focusItem(which) {
    const { list } = parts();
    if (!list) return;
    const items = visibleItems(list);
    if (!items.length) return;
    const idx = which === 'last' ? items.length - 1 : 0;
    items[idx].focus();
}

function open(focus) {
    const { button, list } = parts();
    if (!button || !list) return;
    list.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    openExclusive(POP_ID, () => {
        const cur = parts().list;
        hide(!!cur && cur.contains(document.activeElement));
    }, { roots: () => [document.querySelector('.navbar-tabs .navbar-more-wrap')] });
    if (focus) focusItem(focus);
}

function moveFocus(list, step) {
    const items = visibleItems(list);
    if (!items.length) return;
    const at = items.indexOf(document.activeElement);
    const next = at < 0 ? (step > 0 ? 0 : items.length - 1) : (at + step + items.length) % items.length;
    items[next].focus();
}

let wired = false;

export function setupNavMore() {
    if (wired) return;
    wired = true;

    document.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;
        const button = target.closest(BUTTON);
        if (button) {
            e.preventDefault();
            if (isOpen()) {
                close(false);
            } else {
                // e.detail === 0: 키보드(Enter · Space)로 누른 클릭 — 첫 항목으로 들어간다.
                open(e.detail === 0 ? 'first' : null);
            }
            return;
        }
        // 사본 링크: 이동은 링크(와 SPA 라우터)가 맡고, 메뉴만 닫는다.
        if (target.closest('.navbar-tabs .navbar-more-item')) close(false);
    });

    document.addEventListener('keydown', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target || e.altKey || e.ctrlKey || e.metaKey) return;
        if (target.closest(BUTTON)) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                open(e.key === 'ArrowUp' ? 'last' : 'first');
            }
            return;
        }
        const list = target.closest(LIST);
        if (!list) return;
        switch (e.key) {
        case 'ArrowDown':
            e.preventDefault();
            moveFocus(list, 1);
            break;
        case 'ArrowUp':
            e.preventDefault();
            moveFocus(list, -1);
            break;
        case 'Home':
            e.preventDefault();
            focusItem('first');
            break;
        case 'End':
            e.preventDefault();
            focusItem('last');
            break;
        case ' ': {
            // 메뉴 항목은 Space 로도 누른다 (링크는 Enter 만 기본으로 받는다).
            const item = target.closest('.navbar-more-item');
            if (item) {
                e.preventDefault();
                item.click();
            }
            break;
        }
        case 'Tab':
            // 목록을 떠나면 닫는다 — 포커스는 Tab 이 옮기는 곳으로 먼저 가고(그래서 한 박자
            // 뒤에 닫는다), 닫힌 뒤 단추로 되돌리지 않는다.
            setTimeout(() => close(false), 0);
            break;
        default:
            // Esc 는 팝오버 등록부가 (캡처 단계에서) 닫고 포커스를 단추로 돌려준다.
            break;
        }
    });
}

setupNavMore();
